import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`El capell és de 4 a 12 cm de diàmetre, convex i torna aplanat, de color marró o gris, amb taques circulars i concèntriques de color marró obscur i contorn més clar i enrollat cap abaix. Les làmines són adherents, amb petites làmines intercalades de color marró clar. Les espores són de color gris-rosat en massa, de 6-7,5 x 3,5-4 micres. El peu és més o manco cilíndric, massís, de color semblant al de les làmines.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      